let domain = '.saas.bianzheng.cloud';
export default domain;
